export class CapitalIncrease {
  url:string | undefined;
  title:string | undefined;


  type:string | undefined;
  capitalIncreaseType:string | undefined;
  commentCount:number | undefined;
  id:string | undefined;
  amount:string | undefined;
  priority:string | undefined;
  date:Date | undefined;
  createDate:Date | undefined;
  lastModifiedDate:Date | undefined;
  code:string | undefined;
  name:string | undefined;
  rate:number | undefined;
  lang:string | undefined;
  country:string | undefined;
  spkApproval:string | undefined;
  startDateString:string | undefined;
  endDateString:string | undefined;

  startDate:Date | undefined;
  endDate:Date | undefined;

}
